/**
 * Created by PhpStorm
 * Author: Mikhail Zheludkov <mzheludkov@clubautomation.com>
 * Date: 02/29/2016
 * Time: 12:31 PM
 */

/**
 * A widget for Tags Input control
 */
(function($) {
    $.widget('ca.caTagsInput',{
        options: {
            width: 'auto',
            height: 'auto',
            placeholder: 'Add a tag',
            delimiter: ',',
            autosize: false,
            minInputWidth: false,
            maxInputWidth: false
        },

        _create: function() {
            var self = this;

            this.element.tagsInput({
                width: self.options.width,
                height: self.options.height,
                defaultText: self.options.placeholder,
                delimiter: self.options.delimiter,
                autosize: self.options.autosize,
                minInputWidth: self.options.minInputWidth,
                maxInputWidth: self.options.maxInputWidth
            });
        },
        
        removeAll: function() {
            this.element.importTags('');
        }
    });
})(jQuery);
